import { combineReducers } from 'redux';

import { Reducer } from '../../../../types';
import { StateImageList, ScriptEditorAction } from '../../types';

import { stripItems } from '../../../../../utility/store';
import {
  getDocumentListRequest,
  getDocumentListSuccess,
  getDocumentListFail,
  setOpenDocumentPageInstructionModal,
} from '../../actions';

type ReducerOf<T extends keyof StateImageList> = Reducer<StateImageList, ScriptEditorAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getDocumentListRequest.type:
      return state ? stripItems(state) : null;

    case setOpenDocumentPageInstructionModal.type:
      return action.payload ? state : null;

    case getDocumentListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getDocumentListRequest.type:
      return true;

    case getDocumentListSuccess.type:
    case getDocumentListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateImageList>({
  data,
  loading,
});
